import { useState, useEffect } from "react";
import { useGetAllAttemptQuery } from "src/services/AttemptService";

const useAttempt = () => {
    const [attempt, setAttempt] = useState<any[]>([]);
    const [isDataLoading, setIsDataLoading] = useState(true);

    const { data, isLoading, isFetching } = useGetAllAttemptQuery("");

    useEffect(() => {
        if (isLoading || isFetching) {
            setIsDataLoading(true);
        } else {
            const result: any[] = data?.data;
            setAttempt(result || []);
            setIsDataLoading(false);
        }
    }, [data, isLoading, isFetching]);

    return { attempt, isDataLoading };
};

export default useAttempt;
